import { features } from '@/mocks/home';

export default function FeatureSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择俺去也
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            四大核心优势，打造极致的在线娱乐体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-300 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}